module.exports = __webpack_public_path__ + "img/sunny-down.094555fe.png";